import "../0.styles.css";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Container, Grid, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Switch } from "@mui/material";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { deleteTableDots, functions, instance, validateFunction } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useMemo, useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";

function InstruccionesFormulario() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [clave, setClave] = useState("");
  const [titulo, setTitulo] = useState("");
  const [contenido, setContenido] = useState("");
  const [activo, setActivo] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });

  deleteTableDots(1);

  const columns = useMemo(() => [
    { accessorKey: "Id", header: "ID" },
    { accessorKey: "Clave", header: "Clave" },
    { accessorKey: "Titulo", header: "Título" },
    { accessorFn: (row) => row.Activo ? "Sí" : "No", id: "activo", header: "Activo" },
    {
      accessorFn: () => "edit",
      id: "edit",
      header: "",
      size: 50,
      enableColumnFilter: false,
      Cell: ({ row }) => validateFunction(user, functions.ManageInstrucciones) && (
        <Button onClick={() => handleEditar(row.original)}>
          <EditTwoToneIcon /> Editar
        </Button>
      ),
    },
  ], []);

  function populateTable() {
    instance.get("/instruccionFormulario/listCompleto")
      .then((res) => setItems(res.data))
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  }

  if (isLoading) {
    populateTable();
    setLoading(false);
  }

  const handleEditar = (row) => {
    setEditId(row.Id);
    setClave(row.Clave);
    setTitulo(row.Titulo);
    setContenido(row.Contenido);
    setActivo(!!row.Activo);
    setOpenForm(true);
  };

  const handleGuardar = () => {
    if (!clave || !titulo || !contenido) {
      setDialog({ title: "Aviso", text: "Debe ingresar la clave, el título y el contenido." });
      setOpenDialog(true);
      return;
    }
    const payload = { clave, titulo, contenido, idUsuario: user.id };

    const request = editId
      ? instance.put("/instruccionFormulario/actualizar", { id: editId, activo, ...payload })
      : instance.post("/instruccionFormulario/crear", payload);

    request
      .then(() => {
        setDialog({ title: "Aviso", text: editId ? "Instrucción actualizada exitosamente." : "Instrucción creada exitosamente." });
        setOpenDialog(true);
        limpiarForm();
        setOpenForm(false);
        populateTable();
      })
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  };

  const limpiarForm = () => {
    setEditId(null);
    setClave("");
    setTitulo("");
    setContenido("");
    setActivo(true);
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container maxWidth="xl" sx={{ marginTop: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 4 }}>
          <Grid container gap={{ xs: "0px", sm: "12px" }}>
            <Grid item xs={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  pagination: { pageSize: 10 },
                  showColumnFilters: false,
                  columnVisibility: { Id: false, edit: validateFunction(user, functions.ManageInstrucciones) },
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableGlobalFilter={true}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                renderTopToolbarCustomActions={() => (
                  validateFunction(user, functions.ManageInstrucciones) && (
                  <IconButton color="success" onClick={() => setOpenForm(true)} variant="contained">
                    <AddCircleTwoToneIcon />
                    <p className="IconButtonText">Agregar</p>
                  </IconButton>
                  )
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editId ? "Editar instrucción" : "Nueva instrucción"}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                required fullWidth label="Clave" value={clave}
                onChange={(e) => setClave(e.target.value)}
                helperText="Debe coincidir con la clave que usa el formulario (ej. UPSE2, UPSE4)"
              />
            </Grid>
            {editId && (
              <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={<Switch checked={activo} onChange={(e) => setActivo(e.target.checked)} />}
                  label="Activo"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField required fullWidth label="Título" value={titulo} onChange={(e) => setTitulo(e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required fullWidth multiline rows={8}
                label="Contenido"
                value={contenido}
                onChange={(e) => setContenido(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { limpiarForm(); setOpenForm(false); }}>Cancelar</Button>
          <Button variant="contained" onClick={handleGuardar}>{editId ? "Actualizar" : "Crear"}</Button>
        </DialogActions>
      </Dialog>

      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </LoaderBox>
  );
}

export { InstruccionesFormulario };
